// Favorite toggle with local favorite state -- used for flow type since it does not have usageInfo
// Can remove when/if flow's usageInfo is implemented

import React from 'react';

import { FavoriteToggle } from './FavoriteToggle';

export class FavoriteToggleWithLocalState extends React.PureComponent<FavoriteToggleWithLocalState.Props, FavoriteToggleWithLocalState.State> {

  constructor(props: FavoriteToggleWithLocalState.Props, state: FavoriteToggleWithLocalState.State) {
    super(props, state);
    this.state = { isFavorite: props.isFavorite };
  }

  public render() {
    return (
      <FavoriteToggle
        isFavorite={this.state.isFavorite}
        onAddFavorite={this.onAddFavorite}
        onRemoveFavorite={this.onRemoveFavorite}
        isTabbable={this.props.isTabbable}
        hideHelpTooltip={true}
      />
    );
  }

  private onAddFavorite = () => {
    this.props.onAddFavorite();
    this.setState({ isFavorite: true });
  };

  private onRemoveFavorite = () => {
    this.props.onRemoveFavorite();
    this.setState({ isFavorite: false });
  };
}

export namespace FavoriteToggleWithLocalState {
  export interface Props {
    isFavorite: boolean;
    onAddFavorite: () => void;
    onRemoveFavorite: () => void;
    isTabbable: boolean;
  }

  export interface State {
    isFavorite: boolean;
  }
}
